import React from 'react'
import get from 'lodash/get'
import { PriceGuidanceInlineBox, airTheme } from '@pcln/fly-ui-components'
import { Box } from 'pcln-design-system'
import styled from 'styled-components'

const WrapperBox = styled(Box)`
  ${airTheme.flyQueries.tablet} {
    margin-left: 0px;
    margin-right: 0px;
  }
`

export function getPriceGuidanceNode({ priceGuidanceData, minimumRetailPrice, firstListing }) {
  const filteredMin = get(firstListing, 'totalPriceWithDecimal.price')
  const actualPrice = minimumRetailPrice || filteredMin
  const isEligible = priceGuidanceData?.isEligible && actualPrice && actualPrice < priceGuidanceData?.high

  if (isEligible) {
    return {
      hide: false,
      component: (
        <WrapperBox ml='10px' mr='14px'>
          <PriceGuidanceInlineBox
            actualPrice={actualPrice}
            lowPrice={priceGuidanceData.low}
            highPrice={priceGuidanceData.high}
          />
        </WrapperBox>
      ),
    }
  }

  return null
}
